import rightDoorClassic from 'assets/warehouse/classic/rightDoor.png'
import leftDoorClassic from 'assets/warehouse/classic/leftDoor.png'
import rightDoorHT from 'assets/warehouse/htbox/rightDoor.png'
import leftDoorHT from 'assets/warehouse/htbox/leftDoor.png'
import rightDoorMM from 'assets/warehouse/mm/rightDoor.png'
import leftDoorMM from 'assets/warehouse/mm/leftDoor.png'
import shadow from 'assets/warehouse/shadow.png'
import Alert from './Alert'
import React from 'react'
import './style.scss'

interface WarehouseProps {
  warning?: boolean
  showShadow?: boolean
  lock?: warehouse.WarehouseLockState
  door?: warehouse.WarehouseDoorState
  alert?: warehouse.WarehouseAlert
}

const Warehouse: React.FC<WarehouseProps> = ({ lock = 'locked', door = 'closed', warning, alert, showShadow = false }) => {
  return (
    <div className={`warehouse__animation --${lock} --${door} ${warning ? ' --warning' : showShadow ? ' --shadow' : ''}`}>
      {process.env.REACT_APP_TYPE === 'mm'
        ? <div className='animation__interior'>
          <img className='animation__door --left' src={leftDoorMM} alt='door' />
          <img className='animation__door --right' src={rightDoorMM} alt='door' />
          <img className='animation__shadow' src={shadow} alt='shadow' />
          {alert && <Alert
            {...alert}
          />}
        </div>
        : process.env.REACT_APP_TYPE === 'rze01'
          ? <div className='animation__interior'>
            <img className='animation__door --left' src={leftDoorHT} alt='door' />
            <img className='animation__door --right' src={rightDoorHT} alt='door' />
            <img className='animation__shadow' src={shadow} alt='shadow' />
            {alert && <Alert
              {...alert}
            />}
          </div>
          : <div className='animation__interior'>
            <img className='animation__door --left' src={leftDoorClassic} alt='door' />
            <img className='animation__door --right' src={rightDoorClassic} alt='door' />
            <img className='animation__shadow' src={shadow} alt='shadow' />
            {alert && <Alert
              {...alert}
            />}
          </div>}
    </div>
  )
}

export default Warehouse